window.$ = window.JQuery;

const moment = require('moment');
require('./modules/sidebar');
require('./modules/app');
require('./modules/app.contact.controller');
require('./modules/app.feedback.controller');
require('./modules/app.cart.controller');
require('./modules/app.checkout.controller');
require('./modules/app.carticon.controller');
require('./modules/app.subservices.controller');
require('./modules/page.feedback.list');
require('./modules/page.feedback.create');
require('./modules/page.business-services');
require('./modules/page.booking');

require('./modules/currency-switcher');
require('./modules/custombox');
require('./modules/ecommerce');
require('./modules/util');
require('./modules/promocode');
require('./modules/page.our-fleet');
require('./modules/tour-names.js');

require('./modules/global');
require('./modules/global.menu');
require('./modules/app.http.interceptor');
require('./modules/header.widgets');
require('./modules/ecommerceGTag.js');


require('./modules/components/calendar/calendar.js');
require('./modules/components/calendar/calendar-prices.js');
require('./modules/components/subproducts-list/subproducts-selection.js');
require('./modules/components/subproducts-list/subproducts-prices.js');
require('./modules/components/subproducts-list/subproducts-privacy-switcher.js');
require('./modules/components/subproducts-list/helpers.js');

require('./modules/components/service-form/service-form.js');

require('./modules/components/pickups-map/pickups-map.js');
require('./modules/components/booking-form/booking-form.js');
require('./modules/components/booking-form/booking-people-count.js');
require('./modules/components/booking-form/booking-seats-count.js');

require('./modules/components/widget-rating/widget-rating.js');